<script>
	import { fade } from "svelte/transition";
	import { cubicOut } from "svelte/easing";

	import PointsWrapper from "./points/PointsWrapper.svelte";

	import { dataManufacturersEuropeUS } from "../data";

	export let id;
	export let map;
	export let transitionIn = { duration: 2000, easing: cubicOut };
	export let transitionOut = { duration: 2000, easing: cubicOut };
</script>

<div class="manufacturers" {id} in:fade={transitionIn} out:fade={transitionOut}>
	{#if map === 'us'}
		<div class="headline" in:fade={transitionIn}>DIE 100 GRÖSSTEN US-WAFFENFABRIKEN</div>
	{:else}
		<div class="headline" in:fade={transitionIn}>DIE EUROPÄISCHEN STANDORTE DER MUTTERKONZERNE</div>
	{/if}
	<div class="container">
		<PointsWrapper {...$$props} data={dataManufacturersEuropeUS} noPositionTweening={true} />
	</div>
</div>

<style lang="scss">
	.manufacturers {
		width: 100%;
		height: 100%;
		// max-height: 90vh;
		display: flex;
		flex-direction: column;
		@media (max-width: $breakpoint-mobile) {
			margin-top: 20px;
		}
	}

	.container {
		height: 100%;
		overflow: hidden;
		padding-top: 30px;
		// transform: scale(0.95) translateX(0%);
	}

	.headline {
		@include headline;
	}
</style>
